// src/components/Footer.tsx
import { Link } from './Router';
import { Phone, Mail, MapPin, Share2, Facebook, Twitter, Linkedin } from 'lucide-react';
import { FaFacebook, FaTwitter, FaInstagram, FaYoutube } from 'react-icons/fa';

export function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="w-full px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center mb-4">
              <img 
                src="https://www.argusautomobile.com/logo.png" 
                alt="Argus Logo" 
                className="h-20 w-auto object-contain"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Le marketplace automobile de confiance en Tunisie, proposant des estimations précises basées sur l'IA pour simplifier votre expérience d'achat et de vente.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Liens rapides</h3>
            <ul className="space-y-2">
              <li><Link to="/annonces" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">Annonces</Link></li>
              <li><Link to="/neuf" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">Prix du neuf</Link></li>
              <li><Link to="/estimateur" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">Estimateur IA</Link></li>
              <li><Link to="/soumettre-annonce" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">Vendre votre voiture</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li><Link to="/estimateur" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">Estimation IA</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">Assurance Auto</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">Financement</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">Inspection Véhicule</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <Phone className="h-5 w-5 mr-3 text-gray-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">+216 98 221 229</span>
              </li>
              <li className="flex items-start">
                <Mail className="h-5 w-5 mr-3 text-gray-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">contact@argusautomobile.tn</span>
              </li>
              <li className="flex items-start">
                <MapPin className="h-5 w-5 mr-3 text-gray-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">Bureau F2, Immeuble les Pyramides, Avenue d'Afrique Menzah 5. Tunis</span>
              </li>
            </ul>

            <div className="mt-6">
              <h4 className="text-lg font-semibold mb-4">Suivez-nous</h4>
              <div className="flex space-x-4">
                <a href="https://www.facebook.com/ArgusTunisie/?ref=bookmarks" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-gray-400 hover:text-white transition-colors duration-200">
                  <FaFacebook className="h-6 w-6" />
                </a>
                <a href="https://www.instagram.com/argusautomobile.tn/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-gray-400 hover:text-white transition-colors duration-200">
                  <FaInstagram className="h-6 w-6" />
                </a>
                <a href="https://x.com" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)" className="text-gray-400 hover:text-white transition-colors duration-200">
                  <FaTwitter className="h-6 w-6" />
                </a>
                <a href="https://www.youtube.com/channel/UCLZ-Rn-kfffqaEqW5XZhQcQ" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="text-gray-400 hover:text-white transition-colors duration-200">
                  <FaYoutube className="h-6 w-6" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-800">
        <div className="w-full px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Argus Tunisie. Tous droits réservés.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}